import { inject, Service } from '@angular/core';
import encUtf8 from 'crypto-js/enc-utf8';
import aes from 'crypto-js/aes';
import modeEcb from 'crypto-js/mode-ecb';
import padPkcs7 from 'crypto-js/pad-pkcs7';
import { CookieService } from 'ngx-cookie';

@Service()
export class IdEncryptionService {
  private cookieService = inject(CookieService);

  private async encryptString(value: string, keyString: string) {
    const src = encUtf8.parse(value);
    const key = encUtf8.parse(keyString);
    const cypher = aes.encrypt(src, key, { mode: modeEcb, padding: padPkcs7 }).toString();
    return encodeURIComponent(cypher);
  }

  async encryptWithSession(value: string | number) {
    if (typeof value === 'number') {
      value = value.toString();
    }
    const sessionId = this.cookieService.get('merkur_user_session_id');
    const key = sessionId.substr(0, 16);
    return this.encryptString(value, key);
  }
}
